<template>
  <div :class="{'hidden':hidden}" class="pagination-container">
    <el-pagination
      v-if="mini"
      no="mini"
      small
      :current-page.sync="currentPage"
      :page-size="pageSize"
      :pager-count="9"
      class="mini"
      layout="prev, pager, next"
      :total="validPageCount?undefined:total"
      :page-count="pageCount"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
    <el-pagination
      v-else
      no="pagination"
      :background="background"
      :current-page.sync="currentPage"
      :page-size="pageSize"
      :layout="layout"
      :page-sizes="pageSizes"
      :total="validPageCount?undefined:total"
      :page-count="pageCount"
      :pager-count="5"
      v-bind="$attrs"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
      <span v-if="showCustomTotal" class="el-pagination__total">{{ $t('Message.TotalCost1') }}&nbsp;{{ total }}&nbsp;{{ $t('CargoMsg.Cargo_Pcst') }}</span>
      <span>
        <el-input-number ref="pageSize" v-model.number="pageSize" no="pagePer" style="width: 60px" :controls="false" :precision="0" :min="10" :max="5000" @change="handleInput" @blur="handleSizeChange" />
        {{ $t('common.pagePer') }}
      </span>
    </el-pagination>
    <!-- 显示选中行数的元素 -->
    <div v-show="selectedRowCount > 0" style="float: right;margin-top: -25px;">
      <span style="font-size: 14px;font-weight: bold;margin-right: 20px;">{{ $t('SeaExport.selectedRowCount', [selectedRowCount]) }}</span>
    </div>
  </div>
</template>

<script>
import { scrollTo } from '@/utils/scrollTo'
import { getUserInfo } from '@/utils/auth'

export default {
  name: 'Pagination',
  props: {
    mini: {
      type: Boolean, default: false
    },
    pageCount: {
      type: Number,
      default: undefined
    },
    total: {
      required: true,
      type: Number
    },
    page: {
      type: Number,
      default: 1
    },
    limit: {
      type: Number,
      default: 10
    },
    pageSizes: {
      type: Array,
      default() {
        return [10, 20, 30, 50, 500]
      }
    },
    layout: {
      type: String,
      default: 'total, slot,prev, pager, next, jumper'
    },
    background: {
      type: Boolean,
      default: true
    },
    autoScroll: {
      type: Boolean,
      default: true
    },
    hidden: {
      type: Boolean,
      default: false
    },
    configModule: {
      type: String,
      default: () => null
    },
    selectedRowCount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      userInput: null,
      realtotal: 0 // 实际总数
    }
  },
  computed: {
    validPageCount() {
      return typeof this.pageCount === 'number'
    },
    showCustomTotal() {
      if (this.validPageCount) {
        const index = this.layout.split(',').findIndex(p => p.trim() === 'total')
        return index >= 0
      }
      return false
    },
    currentPage: {
      get() {
        return this.page
      },
      set(val) {
        this.$emit('update:page', val)
      }
    },
    pageSize: {
      get() {
        return this.limit
      },
      set(val) {
        this.$emit('update:limit', val)
      }
    }
  },
  watch: {
    configModule(val) {
      if (val) {
        const currentUserInfo = getUserInfo()
        const cachePageSize = JSON.parse(localStorage.getItem(`local_pagination_page_size_cache_${currentUserInfo.tenantId}_${currentUserInfo.userId}_${this.configModule}`))
        if (cachePageSize) {
          console.log(cachePageSize)
          this.pageSize = cachePageSize
        }
      }
    }
  },
  mounted() {
    if (this.configModule) {
      const currentUserInfo = getUserInfo()
      const cachePageSize = JSON.parse(localStorage.getItem(`local_pagination_page_size_cache_${currentUserInfo.tenantId}_${currentUserInfo.userId}_${this.configModule}`))
      if (cachePageSize) {
        console.log(cachePageSize)
        this.pageSize = cachePageSize
      }
    }
  },
  methods: {
    handleSizeChange(e) {
      console.log('pagination', e, this.$refs.pageSize)
      if (!this.userInput) {
        return
      }
      this.sieChange(Number(e.target.value))
    },
    handleCurrentChange(val) {
      if (this.realtotal > 0) {
        const lastPage = Math.ceil(this.realtotal / this.limit) // 实际页数
        if (val > lastPage) val = lastPage
        this.currentPage = val
        this.realtotal = 0
      }
      this.$emit('pagination', { page: val, limit: this.pageSize })
      if (this.autoScroll) {
        scrollTo(0, 800)
      }
    },
    handleInput(value, oldVal) {
      if (value !== oldVal) {
        this.userInput = value
        this.sieChange(value)
      }
    },
    sieChange(val) {
      this.pageSize = val
      if (this.pageSize < 10) {
        this.$message.warning('不能小于10')
        this.pageSize = 10
      }
      if (this.pageSize > 5000) {
        this.$message.warning('不能大于5000')
        this.pageSize = 5000
      }
      if (this.configModule) {
        const currentUserInfo = getUserInfo()
        localStorage.setItem(
          `local_pagination_page_size_cache_${currentUserInfo.tenantId}_${currentUserInfo.userId}_${this.configModule}`,
          val
        )
      }
      this.currentPage = 1
      this.$emit('pagination', { page: this.currentPage, limit: this.pageSize })
      this.userInput = null
      if (this.autoScroll) {
        scrollTo(0, 800)
      }
    }
  }
}
</script>

<style lang="scss">
.pagination-container {
  /*background: #fff;*/
  padding: 5px 10px;
  margin: 0px;
  .el-input__inner{
    padding:0 10px!important;
  }
}

.pagination-container.hidden {
  display: none;
}

.mini {
  font-size: 12px !important;
}
</style>

